import { useSimpleInput } from '@gasbuddy/react-hooks';
import { useMemo } from 'react';
import { getVehicleYearOptions } from '../utils/vehicle';
import useVehicleMakes, { useVehicleMakeOptions } from './useVehicleMakes';
import useVehicleModels, { useVehicleModelOptions } from './useVehicleModels';
import useVehicleTrims, { useVehicleTrimOptions } from './useVehicleTrims';

// TODO Apply this to all vehicle forms
export default function useVehicleForm(source = 'NHTSA') {
  const [year, handleYear] = useSimpleInput();
  const [make, handleMake] = useSimpleInput();
  const [model, handleModel] = useSimpleInput();
  const [trim, handleTrim] = useSimpleInput();
  const { data: makesData, error: errorFetchingMakes, loading: isFetchingMakes } = useVehicleMakes(source);
  const { data: modelsData, error: errorFetchingModels, loading: isFetchingModels } = useVehicleModels(parseInt(make, 10), parseInt(year, 10), source);
  const yearOptions = useMemo(() => getVehicleYearOptions(), []);
  const makeOptions = useVehicleMakeOptions(makesData?.vehicleMakes);
  const modelOptions = useVehicleModelOptions(modelsData?.vehicleModels);

  const { data: trimsData, error: errorFetchingTrims, loading: isFetchingTrims } = useVehicleTrims(
    parseInt(modelOptions.find(mo => mo.value === model)?.value, 10),
    parseInt(year, 10),
  );
  const trimOptions = useVehicleTrimOptions(trimsData?.vehicleTrims);

  return {
    error: errorFetchingMakes || errorFetchingModels || errorFetchingTrims,
    loading: (isFetchingMakes && 'makes') || (isFetchingModels && 'models') || (isFetchingTrims && 'trims'),
    yearOptions,
    makeOptions,
    modelOptions,
    trimOptions,
    handleYear,
    handleMake,
    handleModel,
    handleTrim,
    year,
    make,
    model,
    trim,
  };
}
